import React, {useEffect, useState} from 'react'
import {useFormContext} from 'react-hook-form';
import {Button} from '../../../../../../components/Button';
import {cnCreateForm} from '../../../FormModule';
import {OPTION_TYPE_JSON} from "common-code/lib/constants";
import {IOption} from 'common-code/lib/interfaces/option/IOption';
import {IOptionHiddenJson} from '../../../../../../../../common-code/interfaces/option/IOptionHiddenJson';
import {IFormInput} from "../../../initialValue";
import {initialFrontPlank} from "./initialFrontPlank";
import FrontPlank from "./FrontPlank";
import ModalFrontPlanks from "./ModalFrontPlanks";
import {validateFrontPlank} from "./validateFrontPlank";
import {
    ISaveCorpusFrontPlankData
} from "../../../../../../../../common-code/interfaces/saveData/ISaveCorpusFrontPlankData";
import {TOptionalPoint3D} from "../../../../../../../../common-code/types/TOptionalPoint3D";

function FrontPlanks() {

    const {setValue, getValues} = useFormContext<IFormInput>();
    const frontPlanksInitional = getValues("frontPlanks") ? getValues("frontPlanks")?.value : [];
    const [arrFrontPlanks, setArrFrontPlanks] = React.useState <ISaveCorpusFrontPlankData[]>(frontPlanksInitional);
    const [modal, setModal] = React.useState<boolean>(false);

    const frontPlanksData: IOption =
        {
            id: "frontPlanks",
            title: "ЛДСП Планки",
            sort: 5,
            type: OPTION_TYPE_JSON,
            value: arrFrontPlanks,
        } as IOptionHiddenJson;

    useEffect(() => {
        if (arrFrontPlanks.length > 0) {
            setValue("frontPlanks", frontPlanksData);
        } else {
            setValue("frontPlanks", null);
        }
        // eslint-disable-next-line
    }, [arrFrontPlanks]);

    const [newFrontPlank, setNewFrontPlank] = useState<Record<string, string | number | boolean>>(initialFrontPlank(null));

    const createFrontPlank = ({width, position, marginX, marginY, marginZ}: Record<string, string | number | boolean>): ISaveCorpusFrontPlankData => {
        let yPosition = undefined;
        let resultMargin: TOptionalPoint3D | undefined;

        switch (position) {
            case 'top':
                yPosition = '%100';
                break;
            case 'center':
                yPosition = '%50';
                break;
            case 'bottom':
                yPosition = '%0';
                break;
        }
        if (!isNaN(+marginX) || !isNaN(+marginY) || !isNaN(+marginZ)) {
            resultMargin = {
                x: !isNaN(+marginX) ? +marginX : undefined,
                y: !isNaN(+marginY) ? +marginY : undefined,
                z: !isNaN(+marginZ) ? +marginZ : undefined,
            };
        }

        return {
            id: 0,
            initSizes: {width: +width},
            initPosition: {
                y: yPosition
            },
            margin: resultMargin
        }
    }

    const handleSubmit = () => {
        const error = validateFrontPlank(newFrontPlank);
        if (error) {
            setNewFrontPlank({...newFrontPlank, error});
            return;
        }
        setArrFrontPlanks([...arrFrontPlanks, createFrontPlank(newFrontPlank)]);
        setModal(false);
    }

    const handleToggleModal = () => {
        setModal(!modal);
    }

    return (
        <>
            <h3 className={cnCreateForm('Header')}>ЛДСП Планки</h3>

            {arrFrontPlanks.map((plank, index) =>
                <FrontPlank
                    arrFrontPlanks={arrFrontPlanks}
                    setArrFrontPlanks={setArrFrontPlanks}
                    frontPlank={plank}
                    key={`${index}${plank.initPosition?.x}
                    ${plank.initPosition?.y}
                    ${plank.initPosition?.z}`}
                    index={index}
                    createFrontPlank={createFrontPlank}
                />
            )
            }

            <Button
                className={cnCreateForm('Button')}
                type={'button'}
                text={`Добавить планку`}
                leftIcon={{path: 'plus2', width: 16, height: 16, marginRight: 8}}
                mods={{
                    mods: {bkg: 'white', color: 'lightGreen', border: 'lightGreen', fill: 'lightGreen'},
                    hover: {mods: {bkg: 'lightGreen', color: 'white', fill: 'white'}}
                }}
                callBack={handleToggleModal}
            />

            <ModalFrontPlanks
                modal={modal}
                handleToggleModal={handleToggleModal}
                handleSubmit={handleSubmit}
                newFrontPlank={newFrontPlank}
                setNewFrontPlank={setNewFrontPlank}
                keyValue={`#addFrontPlank`}
            />

            <hr/>
        </>
    )
}

export default FrontPlanks